<template>
  <div class="hbb">
    <div class="hbb_modalBig"></div>
    <div class="hbb_modal">
      <img src="@assets/images/pic_Identifying.gif" alt />
      <p>{{text}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "加载中..."
    }
  }
};
</script>

<style>
.hbb_modalBig {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #000;
  opacity: 0.5;
      z-index: 99;
}
.hbb_modal {
  display: flex;
  width: 110px;
  height: 110px;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  z-index: 99999;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
}
.hbb_modal img {
  width: 40px;
  height: 40px;
  margin-top: 20px;
}
.hbb_modal p {
  color: #fff;
  margin-top: 15px;
  font-size: 12px !important;
}
</style>